/* NavigationBulletsTemplate */
import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { SliderComponent } from '../cwc-slider';

/**
 * Definition of  parameters that the template needs to work.
 */
interface NavigationBulletsTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: SliderComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const NavigationBulletsTemplate: FunctionalComponent<NavigationBulletsTemplateProps> = ({ controller }) => {
  if (controller.slides.length <= 1) {
    return;
  }

  return (
    <div class={`navigation-bullets ${controller.element.querySelector('[slot="preview"]') && 'hide-desktop'}`}>
      {Array.from(controller.getSlidesWithoutClones()).map((_, i) => (
        <div class="bullet-container" onClick={() => controller.slideTo(i)}>
          <span class={`bullet ${controller.visibleSlides.includes(i) && 'active'}`} />
        </div>
      ))}
    </div>
  );
};

export default NavigationBulletsTemplate;
